import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface IParametersFormMeta {
    refCurrencyAmount: FormInputMeta;
    refCurrency: FormInputMeta;
    period: FormInputMeta;
    hour: FormInputMeta;
    lastProcessing: FormInputMeta;
    currencyAmount: FormInputMeta;
    currency: FormInputMeta;
    hpxAccount: FormInputMeta;
    bankAccount: FormInputMeta;
    accountBalance: FormInputMeta;

    // tva1: FormInputMeta;
    // tva2: FormInputMeta;
    // hpx: FormInputMeta;
    // bank: FormInputMeta;
    schema: any;
  }

const ParametersFormMeta = {} as IParametersFormMeta;

ParametersFormMeta.refCurrencyAmount = {
  name: "refCurrencyAmount",
  label: "",
  type: "number",
  validation: yup.string().required("Ce champ est requis"),
}
ParametersFormMeta.refCurrency = {
  label: '',
  name: 'refCurrency',
  type: 'select',
  placeholder: 'Select ...',
  options:  [
      {value: '1', label: 'CFA Franc BEAC'},
      {value: '2', label: 'Devise 2'},
      {value: '3', label: 'Devise 3'},
      {value: '4', label: 'Devise 4'},
      {value: '5', label: 'Devise 5'}
  ],
  validation: yup.string().required("Ce champ est requis"),
}
ParametersFormMeta.period = {
  label: 'Période',
  name: 'period',
  type: 'select',
  placeholder: 'Select ...',
  options:  [
      {value: '1', label: 'Journalier'},
      {value: '2', label: 'Hebdomadaire'},
      {value: '3', label: 'Mensuel'},
  ],
  validation: yup.string().required("Ce champ est requis"),
}

ParametersFormMeta.hour = {
  name: "hour",
  label: "Heure",
  type: "number",
  validation: yup.string().required("Ce champ est requis"),
}
ParametersFormMeta.lastProcessing = {
  name: "lastProcessing",
  label: "Dernier Traitement",
  type: "text",
  validation: yup.string().required("Ce champ est requis"),
}
ParametersFormMeta.currencyAmount = {
  name: "currencyAmount",
  label: "",
  type: "number",
  validation: yup.string().required("Ce champ est requis"),
}
ParametersFormMeta.currency = {
  label: '',
  name: 'currency',
  type: 'select',
  placeholder: 'Select ...',
  options:  [
      {value: '1', label: 'CFA Franc BEAC'},
      {value: '2', label: 'Devise 2'},
      {value: '3', label: 'Devise 3'},
      {value: '4', label: 'Devise 4'},
      {value: '5', label: 'Devise 5'}
  ],
  validation: yup.string().required("Ce champ est requis"),
}
ParametersFormMeta.hpxAccount = {
  name: "hpxAccount",
  label: "Compte HPX",
  type: "text",
  validation: yup.string().required("Ce champ est requis"),
}
ParametersFormMeta.bankAccount = {
  name: "bankAccount",
  label: "Compte Banque",
  type: "text",
  validation: yup.string().required("Ce champ est requis"),
}
ParametersFormMeta.accountBalance = {
  name: "accountBalance",
  label: "Solde Compte",
  type: "number",
  validation: yup.string().required("Ce champ est requis"),
}


/*ParametersFormMeta.tva1 = {
  name: "tva1",
  label: "TVA1",
  type: "text",
  validation: yup.string().required(),
}
ParametersFormMeta.tva2 = {
  name: "tva2",
  label: "TVA2",
  type: "text",
  validation: yup.string().required(),
}
ParametersFormMeta.hpx = {
  name: "hpx",
  label: "Compte HPX",
  type: "text",
  validation: yup.string().required(),
}
ParametersFormMeta.bank = {
  name: "bank",
  label: "Compte Banque",
  type: "text",
  validation: yup.string().required(),
}*/

ParametersFormMeta.schema = yup.object().shape(getValidationSchema(ParametersFormMeta));

export default ParametersFormMeta;